import React from 'react';
import { OverviewComponentType, ProductOverviewRegistry } from '../../../types';
import ApplicationPerformanceScorecard from '@containers/ApplicationPerformanceRedesigned/ApplicationPerformanceStandardMetrics/ApplicationPerformanceScorecard';
import SummaryMetricsPepIRis from '@containers/UserBehaviorEngagement/PepIRis/SummaryMetricsPepIRis';

const scorecards: OverviewComponentType[] = [
  () => (
    <ApplicationPerformanceScorecard
      title={'App Performance'}
      showInfoIcon={true}
    />
  ),
  () => <SummaryMetricsPepIRis title="User Adoption" />,
];

const customOverview: OverviewComponentType | null = null;

const PepIRiSRegistry: ProductOverviewRegistry = {
  scorecards,
  customOverview,
};

export default PepIRiSRegistry;
